import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";

import {
  requestBatchPredictionOutputStatus,
  requestRefreshCsvOutputLinkStatus,
  requestSinglePredictionOutputStatus,
  requestImageFilterStatus,
} from "../effects/prediction-effects";

const initialState = {
  loading: false,
  message: "",
  batchPredictionData: null,
  imagePredictionDetails: null,
  batchPredictionOutput: null,
  singlePredictionOutput: null,
  csvLoading: false,
};

const predictionSlice = createSlice({
  name: slices.prediction,
  initialState,
  reducers: {
    resetPrediction: (state, action) => {
      state.batchPredictionData = null;
      state.batchPredictionOutput = null;
      state.loading = false;
    },
  },
  extraReducers: {
    ...requestBatchPredictionOutputStatus,
    ...requestRefreshCsvOutputLinkStatus,
    ...requestSinglePredictionOutputStatus,
    ...requestImageFilterStatus,
  },
});

const { actions, reducer } = predictionSlice;

export const { resetPrediction } = actions;

export default reducer;
